import { applyMiddleware, compose, legacy_createStore as createStore } from 'redux';
import { createLogger } from 'redux-logger';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
// import DevTools from './redux.devtools';
import reducer from '@mobile-dev/platform/common/redux/reducers';
import { composeWithDevTools } from 'redux-devtools-extension';

function configureStore(initialState = {}) {

    const persistConfig = {
        key: 'uchainRoot',
        storage,
        // whitelist:['otpAuthentication']
    }

    const middleware = [thunk];

    let enhancers = compose(applyMiddleware(...middleware));

    // if (process.env.NODE_ENV === "development") {
    //     middleware.push(createLogger());
    //     enhancers = composeWithDevTools(applyMiddleware(...middleware), DevTools.instrument());
    // }
    /**
     * clearing data after use logout from all states
     */
    const rootReducer = (state, action) => {
        if (action.type === 'USER_LOGOUT') {

            // for all keys defined in your persistConfig(s)
            storage.removeItem('persist:uchainRoot');
            localStorage.removeItem('Flow');
            localStorage.removeItem('carrierName');
            localStorage.removeItem('carrierEnteredPhone');
            window.location.reload();
            // storage.removeItem('persist:otherKey')

            return reducer(undefined, action);
        }
        return reducer(state, action);
    };

    const persistedReducer = persistReducer(persistConfig, rootReducer);

    let store = createStore(persistedReducer, initialState, enhancers);
    let persistor = persistStore(store);

    return { store, persistor }

}

export default configureStore;